import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.ash,
  paraColor: colors.ash,
  subHeadingColor: colors.slateGreen,
  bgColor: colors.white,
  ctaColor: colors.slateGreen,
  textColorDark: colors.ash,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;